import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import ENV_NAMES from '../../../environments/ENV_NAMES';
import { TriggerId } from '../../alerts/models/Alert';
import { AppConfig } from '../../AppConfig';
import { APP_CONFIG } from '../../shared/injectionTokens';
import { getMinuteTimestamp } from '../../utils/date';
import { getMatchingLanguage } from '../../utils/language';
import { AlertResolutionStep } from '../models/AlertResolutionSteps';

import { AlertResolutionGateway } from './AlertResolutionGateway';

@Injectable()
export class HttpAlertResolutionGateway implements AlertResolutionGateway {
    private supportedLanguages$ = new ReplaySubject<string[]>(1);

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG) private appConfig: AppConfig,
    ) {
        this.http.get<string[]>(this.getTranslationPath('languages')).subscribe(this.supportedLanguages$);
    }

    getResolutionPath(triggerId: TriggerId): Observable<AlertResolutionStep[]> {
        return this.http
            .get<
                AlertResolutionStep[]
            >(`https://storage.googleapis.com/servego/${this.getResolvePathDirectory()}/resolve-paths/${triggerId}.json?${getMinuteTimestamp()}`)
            .pipe(map((apiResult) => [...apiResult, { text: 'SUPPORT_CONTACT_STEP_TEXT', image: 'support-contact' }]));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getTranslations(locale: string): Observable<any> {
        return this.supportedLanguages$.pipe(
            switchMap((languages) => {
                const matchingLanguage = getMatchingLanguage(locale, languages);
                return this.http.get(this.getTranslationPath(matchingLanguage));
            }),
        );
    }

    private getResolvePathDirectory() {
        return this.appConfig.name === ENV_NAMES.PROD ? 'alert-resolution' : 'alert-resolution-draft';
    }

    private getTranslationPath(language: string) {
        return `https://storage.googleapis.com/servego/alert-resolution/i18n/${language}.json?${getMinuteTimestamp()}`;
    }
}
